export const privilegesMapper = {
  polaris_propertyAddon_index: "Polaris::PropertyAddon::index",
  polaris_propertyAttribute_index: "Polaris::PropertyAttribute::index",
  polaris_projectBank_index: "Polaris::ProjectBank::index",
  polaris_projectBank_create: "Polaris::ProjectBank::create",
  polaris_projectBank_read: "Polaris::ProjectBank::read",
  polaris_projectBank_update: "Polaris::ProjectBank::update",
  polaris_projectBank_destroy: "Polaris::ProjectBank::destroy",
  attachment_presigned_url: "Polaris::Attachment::presigned_url",
  attachment_lambda_attachment_callback:
    "Polaris::Attachment::lambda_attachment_callback",
  polaris_unit_change_status: "Polaris::Unit::change_status",
  polaris_unit_index: "Polaris::Unit::index",
  polaris_unit_create: "Polaris::Unit::create",
  polaris_unit_new: "Polaris::Unit::new",
  polaris_unit_edit: "Polaris::Unit::edit",
  polaris_unit_read: "Polaris::Unit::read",
  polaris_unit_update: "Polaris::Unit::update",
  polaris_unit_destroy: "Polaris::Unit::destroy",
  polaris_unit_import_bulk_inventory: "Polaris::Unit::import_bulk_inventory",
  polaris_project_index: "Polaris::Project::index",
  polaris_project_create: "Polaris::Project::create",
  polaris_project_new: "Polaris::Project::new",
  polaris_project_edit: "Polaris::Project::edit",
  polaris_project_read: "Polaris::Project::read",
  polaris_project_update: "Polaris::Project::update",
  polaris_project_destroy: "Polaris::Project::destroy",
  polaris_project_app_status_change: "Polaris::Project::app_status_change",
  polaris_project_listing: "Polaris::Project::listing",
  polaris_client_add_attachments: "Polaris::Client::add_attachments",
  polaris_client_remove_attachments: "Polaris::Client::remove_attachments",
  polaris_client_index: "Polaris::Client::index",
  polaris_client_create: "Polaris::Client::create",
  polaris_client_new: "Polaris::Client::new",
  polaris_client_edit: "Polaris::Client::edit",
  polaris_client_read: "Polaris::Client::read",
  polaris_client_update: "Polaris::Client::update",
  polaris_client_destroy: "Polaris::Client::destroy",
  polaris_client_attach_file: "Polaris::Client::attach_file",
  polaris_client_remove_file: "Polaris::Client::remove_file",
  polaris_client_all_clients: "Polaris::Client::all_clients",
  polaris_client_app_status_change: "Polaris::Client::app_status_change",
  polaris_client_current: "Polaris::Client::current",
  polaris_client_link_device: "Polaris::Client::link_device",
  polaris_client_unlink_device: "Polaris::Client::unlink_device",
  polaris_client_enable_notifications: "Polaris::Client::enable_notifications",
  polaris_client_delete_account: "Polaris::Client::delete_account",
  polaris_client_feedback: "Polaris::Client::feedback",
  polaris_booking_change_assignee: "Polaris::Booking::change_assignee",
  polaris_booking_assignees: "Polaris::Booking::assignees",
  polaris_booking_change_status: "Polaris::Booking::change_status",
  polaris_booking_change_disposition: "Polaris::Booking::change_disposition",
  polaris_booking_add_watcher: "Polaris::Booking::add_watcher",
  polaris_booking_remove_watcher: "Polaris::Booking::remove_watcher",
  polaris_booking_add_comment: "Polaris::Booking::add_comment",
  polaris_booking_update_installments: "Polaris::Booking::update_installments",
  polaris_booking_index: "Polaris::Booking::index",
  polaris_booking_create: "Polaris::Booking::create",
  polaris_booking_new: "Polaris::Booking::new",
  polaris_booking_edit: "Polaris::Booking::edit",
  polaris_booking_read: "Polaris::Booking::read",
  polaris_booking_update: "Polaris::Booking::update",
  polaris_booking_destroy: "Polaris::Booking::destroy",
  polaris_booking_attach_file: "Polaris::Booking::attach_file",
  polaris_booking_remove_file: "Polaris::Booking::remove_file",
  polaris_booking_account_statement: "Polaris::Booking::account_statement",
  polaris_booking_mark_as_transferred: "Polaris::Booking::mark_as_transferred",
  polaris_booking_mark_as_terminated: "Polaris::Booking::mark_as_terminated",
  polaris_booking_mark_as_matured: "Polaris::Booking::mark_as_matured",
  polaris_booking_listing: "Polaris::Booking::listing",
  polaris_booking_process_refund: "Polaris::Booking::process_refund",
  polaris_booking_update_client_contacts:
    "Polaris::Booking::update_client_contacts",
  polaris_booking_update_transfer_fee: "Polaris::Booking::update_transfer_fee",
  polaris_booking_update_cancellation_fee:
    "Polaris::Booking::update_cancellation_fee",
  polaris_recoveryLead_change_assignee:
    "Polaris::RecoveryLead::change_assignee",
  polaris_recoveryLead_assignees: "Polaris::RecoveryLead::assignees",
  polaris_recoveryLead_change_status: "Polaris::RecoveryLead::change_status",
  polaris_recoveryLead_add_watcher: "Polaris::RecoveryLead::add_watcher",
  polaris_recoveryLead_remove_watcher: "Polaris::RecoveryLead::remove_watcher",
  polaris_recoveryLead_add_comment: "Polaris::RecoveryLead::add_comment",
  polaris_recoveryLead_index: "Polaris::RecoveryLead::index",
  polaris_recoveryLead_create: "Polaris::RecoveryLead::create",
  polaris_recoveryLead_read: "Polaris::RecoveryLead::read",
  polaris_recoveryLead_update: "Polaris::RecoveryLead::update",
  polaris_recoveryLead_destroy: "Polaris::RecoveryLead::destroy",
  polaris_payment_change_assignee: "Polaris::Payment::change_assignee",
  polaris_payment_verify_payment: "Polaris::Payment::verify_payment",
  polaris_payment_assignees: "Polaris::Payment::assignees",
  polaris_payment_change_status: "Polaris::Payment::change_status",
  polaris_payment_reject_payment: "Polaris::Payment::reject_payment",
  polaris_payment_index: "Polaris::Payment::index",
  polaris_payment_create: "Polaris::Payment::create",
  polaris_payment_new: "Polaris::Payment::new",
  polaris_payment_edit: "Polaris::Payment::edit",
  polaris_payment_read: "Polaris::Payment::read",
  polaris_payment_update: "Polaris::Payment::update",
  polaris_payment_destroy: "Polaris::Payment::destroy",
  polaris_payment_attach_file: "Polaris::Payment::attach_file",
  polaris_payment_remove_file: "Polaris::Payment::remove_file",
  polaris_payment_payment_receipt: "Polaris::Payment::payment_receipt",
  polaris_payment_send_payment_receipt:
    "Polaris::Payment::send_payment_receipt",
  polaris_installment_index: "Polaris::Installment::index",
  polaris_installment_create: "Polaris::Installment::create",
  polaris_installment_edit: "Polaris::Installment::edit",
  polaris_installment_read: "Polaris::Installment::read",
  polaris_installment_destroy: "Polaris::Installment::destroy",
  polaris_installment_update: "Polaris::Installment::update",
  polaris_taskType_index: "Polaris::TaskType::index",
  polaris_taskType_create: "Polaris::TaskType::create",
  polaris_taskType_read: "Polaris::TaskType::read",
  polaris_taskType_update: "Polaris::TaskType::update",
  polaris_taskType_destroy: "Polaris::TaskType::destroy",
  polaris_task_change_assignee: "Polaris::Task::change_assignee",
  polaris_task_change_due_date: "Polaris::Task::change_due_date",
  polaris_task_assignees: "Polaris::Task::assignees",
  polaris_task_change_status: "Polaris::Task::change_status",
  polaris_task_add_watcher: "Polaris::Task::add_watcher",
  polaris_task_remove_watcher: "Polaris::Task::remove_watcher",
  polaris_task_add_comment: "Polaris::Task::add_comment",
  polaris_task_index: "Polaris::Task::index",
  polaris_task_create: "Polaris::Task::create",
  polaris_task_new: "Polaris::Task::new",
  polaris_task_edit: "Polaris::Task::edit",
  polaris_task_read: "Polaris::Task::read",
  polaris_task_update: "Polaris::Task::update",
  polaris_task_destroy: "Polaris::Task::destroy",
  polaris_task_attach_file: "Polaris::Task::attach_file",
  polaris_task_remove_file: "Polaris::Task::remove_file",
  polaris_quickLink_sort: "Polaris::QuickLink::sort",
  polaris_quickLink_index: "Polaris::QuickLink::index",
  polaris_quickLink_create: "Polaris::QuickLink::create",
  polaris_quickLink_destroy: "Polaris::QuickLink::destroy",
  polaris_applicableTax_index: "Polaris::ApplicableTax::index",
  polaris_applicableTax_create: "Polaris::ApplicableTax::create",
  polaris_applicableTax_new: "Polaris::ApplicableTax::new",
  polaris_applicableTax_read: "Polaris::ApplicableTax::read",
  polaris_applicableTax_update: "Polaris::ApplicableTax::update",
  polaris_applicableTax_destroy: "Polaris::ApplicableTax::destroy",
  polaris_propertyCategory_property_addons:
    "Polaris::PropertyCategory::property_addons",
  polaris_propertyCategory_property_attributes:
    "Polaris::PropertyCategory::property_attributes",
  polaris_propertyCategory_index: "Polaris::PropertyCategory::index",
  polaris_propertyCategory_create: "Polaris::PropertyCategory::create",
  polaris_propertyCategory_read: "Polaris::PropertyCategory::read",
  polaris_propertyCategory_update: "Polaris::PropertyCategory::update",
  polaris_propertyCategory_destroy: "Polaris::PropertyCategory::destroy",
  polaris_propertyType_index: "Polaris::PropertyType::index",
  polaris_propertyType_create: "Polaris::PropertyType::create",
  polaris_propertyType_new: "Polaris::PropertyType::new",
  polaris_propertyType_read: "Polaris::PropertyType::read",
  polaris_propertyType_update: "Polaris::PropertyType::update",
  polaris_propertyType_destroy: "Polaris::PropertyType::destroy",
  polaris_dynamicField_index: "Polaris::DynamicField::index",
  polaris_dynamicField_create: "Polaris::DynamicField::create",
  polaris_dynamicField_read: "Polaris::DynamicField::read",
  polaris_dynamicField_update: "Polaris::DynamicField::update",
  polaris_dynamicField_destroy: "Polaris::DynamicField::destroy",
  polaris_dynamicModel_index: "Polaris::DynamicModel::index",
  user_current: "Polaris::User::current",
  user_permissions: "Polaris::User::permissions",
  user_assigned_relations: "Polaris::User::assigned_relations",
  user_assign_relations: "Polaris::User::assign_relations",
  user_index: "Polaris::User::index",
  user_update: "Polaris::User::update",
  user_active_users: "Polaris::User::active_users",
  user_change_status: "Polaris::User::change_status",
  user_enable_notifications: "Polaris::User::enable_notifications",
  user_feedback: "Polaris::User::feedback",
  polaris_team_index: "Polaris::Team::index",
  polaris_team_create: "Polaris::Team::create",
  polaris_team_new: "Polaris::Team::new",
  polaris_team_edit: "Polaris::Team::edit",
  polaris_team_read: "Polaris::Team::read",
  polaris_team_update: "Polaris::Team::update",
  polaris_team_destroy: "Polaris::Team::destroy",
  polaris_team_projects_recovery_analysis:
    "Polaris::Team::projects_recovery_analysis",
  polaris_team_project_aging: "Polaris::Team::project_aging",
  polaris_team_team_members_recovery_analysis:
    "Polaris::Team::team_members_recovery_analysis",
  polaris_team_team_member_aging: "Polaris::Team::team_member_aging",
  polaris_team_target_statistics: "Polaris::Team::target_statistics",
  polaris_target_index: "Polaris::Target::index",
  polaris_target_create: "Polaris::Target::create",
  polaris_target_read: "Polaris::Target::show",
  polaris_target_update: "Polaris::Target::update",
  polaris_clientContact_edit: "Polaris::ClientContact::edit",
  polaris_clientContact_update: "Polaris::ClientContact::update",
  polaris_clientContact_destroy: "Polaris::ClientContact::destroy",
  polaris_clientContact_create: "Polaris::ClientContact::create",
  polaris_clientContact_new: "Polaris::ClientContact::new",
  polaris_clientContact_index: "Polaris::ClientContact::index",
  role_index: "Fms::Role::index",
  role_create: "Fms::Role::create",
  role_edit: "Fms::Role::edit",
  role_read: "Fms::Role::read",
  role_update: "Fms::Role::update",
  role_destroy: "Fms::Role::destroy",
  polaris_role_index: "Polaris::Role::index",
  polaris_role_create: "Polaris::Role::create",
  polaris_role_edit: "Polaris::Role::edit",
  polaris_role_read: "Polaris::Role::read",
  polaris_role_update: "Polaris::Role::update",
  polaris_role_destroy: "Polaris::Role::destroy",
  polaris_approval_approve: "Polaris::Approval::approve",
  polaris_approval_reject: "Polaris::Approval::reject",
  polaris_approval_index: "Polaris::Approval::index",
  polaris_approval_create: "Polaris::Approval::create",
  polaris_approval_new: "Polaris::Approval::new",
  polaris_approval_read: "Polaris::Approval::read",
  polaris_approval_update: "Polaris::Approval::update",
  polaris_workflow_index: "Polaris::Workflow::index",

  polaris_workflow_read: "Polaris::Workflow::read",
  polaris_kycFile_verify: "Polaris::KycFile::verify",
  polaris_kycFile_index: "Polaris::KycFile::index",
  polaris_kycFile_create: "Polaris::KycFile::create",
  polaris_kycFile_new: "Polaris::KycFile::new",
  polaris_kycFile_edit: "Polaris::KycFile::edit",
  polaris_kycFile_read: "Polaris::KycFile::read",
  polaris_kycFile_update: "Polaris::KycFile::update",
  polaris_kycSection_index: "Polaris::KycSection::index",
  polaris_kycSection_read: "Polaris::KycSection::read",
  polaris_teamMember_listing: "Polaris::TeamMember::listing",
  polaris_teamMember_index: "Polaris::TeamMember::index",
  polaris_teamMember_create: "Polaris::TeamMember::create",
  polaris_teamMember_new: "Polaris::TeamMember::new",
  polaris_teamMember_edit: "Polaris::TeamMember::edit",
  polaris_teamMember_read: "Polaris::TeamMember::read",
  polaris_teamMember_update: "Polaris::TeamMember::update",
  polaris_teamMember_destroy: "Polaris::TeamMember::destroy",
  polaris_refund_create_refund_payment:
    "Polaris::Refund::create_refund_payment",
  polaris_refund_index: "Polaris::Refund::index",
  polaris_refund_create: "Polaris::Refund::create",
  polaris_refund_read: "Polaris::Refund::read",
  polaris_refund_update: "Polaris::Refund::update",
  polaris_refund_destroy: "Polaris::Refund::destroy",
  polaris_comment_index: "Polaris::Comment::index",
  polaris_comment_update: "Polaris::Comment::update",
  polaris_transfer_collect_transfer_fee:
    "Polaris::Transfer::collect_transfer_fee",
  polaris_transfer_index: "Polaris::Transfer::index",
  polaris_transfer_create: "Polaris::Transfer::create",
  polaris_transfer_read: "Polaris::Transfer::read",
  polaris_transfer_update: "Polaris::Transfer::update",
  polaris_widget_read: "Polaris::Widget::read",
  polaris_visualization_index: "Polaris::Visualization::index",
  polaris_bookingNotice_generate_pdf: "Polaris::BookingNotice::notice_pdf",
  polaris_bookingNotice_index: "Polaris::BookingNotice::index",
  polaris_bookingNotice_create: "Polaris::BookingNotice::create",
  polaris_bookingNotice_new: "Polaris::BookingNotice::new",
  polaris_bookingNotice_edit: "Polaris::BookingNotice::edit",
  polaris_bookingNotice_read: "Polaris::BookingNotice::read",
  polaris_bookingNotice_notice_pdf: "Polaris::BookingNotice::notice_pdf",
  polaris_notice_bulk_insert: "Polaris::Notice::bulk_insert",
  polaris_notice_index: "Polaris::Notice::index",
  polaris_notice_create: "Polaris::Notice::create",
  polaris_notice_new: "Polaris::Notice::new",
  polaris_notice_edit: "Polaris::Notice::edit",
  polaris_notice_read: "Polaris::Notice::read",
  polaris_ownership_send_account_statement:
    "Polaris::Ownership::send_account_statement",
  fms_unit_change_status: "Fms::Unit::change_status",
  fms_unit_index: "Fms::Unit::index",
  fms_unit_create: "Fms::Unit::create",
  fms_unit_new: "Fms::Unit::new",
  fms_unit_edit: "Fms::Unit::edit",
  fms_unit_read: "Fms::Unit::show",
  fms_unit_update: "Fms::Unit::update",
  fms_unit_destroy: "Fms::Unit::destroy",
  fms_unit_import_bulk_inventory: "Fms::Unit::import_bulk_inventory",
  fms_unit_set_assignee: "Fms::Unit::set_assignee",

  //FMS Projects
  fms_project_index: "Fms::Project::index",
  fms_project_create: "Fms::Project::create",
  fms_project_edit: "Fms::Project::update",

  //FMS Project Banks
  fms_can_view_banks: "Fms::ProjectBank::index",
  fms_can_add_banks: "Fms::ProjectBank::create",
  fms_can_update_banks: "Fms::ProjectBank::update",

  //FMS Property Types
  fms_can_view_property_types: "Fms::PropertyType::index",
  fms_can_add_property_types: "Fms::PropertyType::create",
  fms_can_update_property_types: "Fms::PropertyType::update",

  //FMS Client

  fms_client_index: "Fms::Client::index",
  fms_client_create: "Fms::Client::create",
  fms_client_update: "Fms::Client::update",
  fms_client_show: "Fms::Client::show",

  //FMS agreement privileges
  fms_agreement_index: "Fms::Agreement::index",
  fms_agreement_update: "Fms::Agreement::update",
  fms_agreement_create: "Fms::Agreement::create",
  fms_agreement_change_status: "Fms::Agreement::change_status",
  fms_agreement_show: "Fms::Agreement::show",

  fms_payment_index: "Fms::Payment::index",
  fms_payment_create: "Fms::Payment::create",
  fms_payment_change_status: "Fms::Payment::change_status",
  fms_payment_set_assignee: "Fms::Payment::set_assignee",
  fms_payment_edit: "Fms::Payment::edit",
  fms_payment_show: "Fms::Payment::show",
  fms_payment_update: "Fms::Payment::update",
  fms_payment_send_receipt: "Fms::Payment::send_payment_receipt",
  fms_payment_download_receipt: "Fms::Payment::download_receipt",
  fms_payment_export_all: "Fms::Payment::generate_all_payments_report",
  fms_payment_bulk_export: "Fms::Payment::generate_selected_payments_report",
  fms_payment_clear_reject_payments: "Fms::Payment::settle_payment",

  //FMS Bills
  fms_can_view_bill_detail: "Fms::MonthlyBill::show",
  fms_can_bulk_import_readings: "Fms::MonthlyBill::bulk_update_from_csv",
  fms_can_bulk_update_due_dates: "Fms::MonthlyBill::bulk_update_due_dates",
  fms_can_change_bill_status: "Fms::MonthlyBill::change_status",
  fms_can_create_monthly_bill: "Fms::MonthlyBill::create",
  fms_can_download_bill: "Fms::MonthlyBill::download",
  fms_can_view_bills_listing: "Fms::MonthlyBill::index",
  fms_can_share_bill: "Fms::MonthlyBill::send_bill_email",
  fms_can_update_bill: "Fms::MonthlyBill::update",
  fms_bulk_export_bills: "Fms::MonthlyBill::generate_selected_bills_report",
  fms_export_bills: "Fms::MonthlyBill::generate_all_bills_report",

  // FMS Work Orders
  fms_work_order_index: "Fms::WorkOrder::index",
  fms_work_order_create: "Fms::WorkOrder::create",
  fms_work_order_change_status: "Fms::WorkOrder::change_status",
  fms_work_order_set_assignee: "Fms::WorkOrder::set_assignee",
  fms_work_order_update: "Fms::WorkOrder::update",
  fms_work_order_detail: "Fms::WorkOrder::show",

  // Tenant Settings
  tenant_settings_update: "Polaris::Tenant::update",

  // FMS Visits
  fms_visit_index: "Fms::Visit::index",
  fms_visit_create: "Fms::Visit::create",
  fms_visit_change_status: "Fms::Visit::change_status",
  fms_visit_update: "Fms::Visit::update",
  fms_visit_detail: "Fms::Visit::show",
  //Developer Portal
  developer_payment_update: "Developer::Payment::update", //x
  developer_verify_payment: "Developer::Payment::verify_payment", //x

  can_view_developer_units: "Developer::Unit::index",
  can_view_developer_units_payments: "Developer::Unit::payments",
  can_view_developer_units_detail: "Developer::Unit::read",
  can_reserve_developer_unit: "Developer::Unit::reserve_unit",
  can_upload_developer_spa: "Developer::Unit::upload_spa", //x
};

const obj = {};

Object.keys(privilegesMapper).forEach((e) => {
  obj[e] = e;
});

export const createPrivilegeObject = (privs) => {
  const privileges = {};
  if (typeof privs === "object" && !Array.isArray(privs)) {
    Object.keys(privs).forEach((key) => {
      const value = privs[key];
      if (typeof value === "object" && !Array.isArray(value)) {
        Object.keys(value).forEach((nestedKey) => {
          privileges[nestedKey] = value[nestedKey];
        });
      }
    });
  }
  return privileges;
};

export const PERMISSION_KEYS = obj;
